import { httpClient } from './httpclient';

var http = httpClient( process.env.CMS_API_URL );

export default http;



// WEBPACK FOOTER //
// ./src/cmsapi.js